export const InvestmentStatusLabel = {
    new: 'New',
    submitted: 'Submitted',
    approved: 'Approved',
    deferred: 'Deferred',
    rejected: 'Rejected',
    planned: 'Planned',
    in_progress: 'In Progress',
    complete: 'Complete',
    cancelled: 'Cancelled',
};
export const InvestmentStatusColor = {
    new: 'gray',
    submitted: 'blue',
    approved: 'green',
    deferred: 'yellow',
    rejected: 'red',
    planned: 'purple',
    in_progress: 'indigo',
    complete: 'emerald',
    cancelled: 'slate',
};
//# sourceMappingURL=investment-status.enum.js.map